import { getHumanReadableTimeDifference } from 'utils/getHumanReadableTimeDifference';

export function getHumanReadableExpiration(
  now: number,
  replyWindowExpiresOn?: Date | null,
): string {
  if (!replyWindowExpiresOn) return '';

  if (now >= replyWindowExpiresOn.getTime()) return 'Reply window closed';

  return `Reply window closes in ${getHumanReadableTimeDifference(
    new Date(now),
    replyWindowExpiresOn,
  )}`;
}
